import { Fragment } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import ListLeads from "./ListLeads";

const LeadListWrapper = () => {

    const breadCrumb = [
        { name: 'Ventas' },
        { name: 'Gestión de contratos' },
        { name: 'Renovaciones (Leads)', href: menuRoutes.leads.path },
    ];

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de renovaciones (Leads)" breadcrumb={breadCrumb} />
                <ListLeads />
            </FiltersProvider>
        </Fragment>
    );
}

export default LeadListWrapper;